import React from "react"
import PropTypes from "prop-types"
import { X } from "lucide-react"
import { Redirect } from "react-router-dom"
import {
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  Button,
  Input,
  Label,
} from "ksc-portal-common-components/shadcn"
import { ADMIN_RESET, LOGIN } from "../../constants"

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

class ForgottenPassword extends React.Component {
  constructor(props) {
    super(props)
    const { usernameDefault } = this.props
    this.state = {
      email: usernameDefault,
      emailError: "",
    }
    this.tryForgotPassword = this.tryForgotPassword.bind(this)
  }

  componentDidMount() {
    const { storePasswordCriteria, passwordCriteria } = this.props
    if (!passwordCriteria) storePasswordCriteria()
  }

  tryForgotPassword(e) {
    e.preventDefault()
    const {
      email: { value },
      forgotPassword,
    } = this.props
    if (validateEmail(value)) {
      this.setState({ emailError: "" })
      forgotPassword()
    } else
      this.setState({
        emailError: "Invalid email address",
      })
  }

  render() {
    const { updateResetUsername, errorMessage, backToLogin, adminOnly } =
      this.props
    const { emailError, email } = this.state
    return (
      <>
        {adminOnly === true && <Redirect to={`/${LOGIN}/${ADMIN_RESET}`} />}
        <CardHeader>
          <Button
            onClick={backToLogin}
            variant="ghost"
            size="icon"
            className="absolute right-3 top-3 rounded-full"
            aria-label="Close"
            data-testid="back-button"
          >
            <X className="h-4 w-4" />
          </Button>
          <CardTitle
            data-testid="hub-login-password-recovery-title"
            className="text-2xl font-medium"
          >
            Forgot Password
          </CardTitle>
          <CardDescription>
            Enter your email id & we will send you link
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={this.tryForgotPassword}>
            <div className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email Address</Label>
                <Input
                  ref={updateResetUsername}
                  id="email"
                  type="email"
                  placeholder="m@example.com"
                  onChange={({ target: { value } }) =>
                    this.setState({ email: value })
                  }
                  value={email}
                  label="email"
                  className={`${emailError ? "border-destructive" : ""}`}
                  data-testid="email-input"
                />
                <p className="text-destructive text-xs">
                  {errorMessage || emailError}
                </p>
                <Button
                  type="submit"
                  variant="default"
                  className="w-full"
                  data-testid="submit-button"
                >
                  Reset
                </Button>
              </div>
            </div>
          </form>
        </CardContent>
      </>
    )
  }
}
ForgottenPassword.propTypes = {
  forgotPassword: PropTypes.func.isRequired,
  updateResetUsername: PropTypes.func.isRequired,
  usernameDefault: PropTypes.string,
  email: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }),
  errorMessage: PropTypes.string,
  backToLogin: PropTypes.func.isRequired,
  storePasswordCriteria: PropTypes.func.isRequired,
  passwordCriteria: PropTypes.shape({}),
  adminOnly: PropTypes.bool,
}

ForgottenPassword.defaultProps = {
  usernameDefault: undefined,
  email: undefined,
  errorMessage: undefined,
  passwordCriteria: null,
  adminOnly: null,
}

export default ForgottenPassword
